import { buildUrl } from '../../../utils/api';

export const fetchAccountPricingTableURL = (accountId: string) =>
  buildUrl(`/api/v2/adm/account/${accountId}/pricing-table`);
